module.exports = __webpack_public_path__ + "static/media/logo-grey.9b18e57a.png";